// English + Arabic translations
export const translations = {
  en: {
    // Nav
    nav_home: "Home",
    nav_properties: "Properties",
    nav_about: "About",
    nav_guide: "Investment Guide",
    nav_contact: "Contact",
    nav_book: "Book Consultation",

    // Hero
    hero_overline: "Independent · UAE Licensed",
    hero_title: "Your Trusted Guide to Dubai's Most Exclusive Off-Plan Investments",
    hero_sub: "Independent Expert. Honest Advice. Life-Changing Properties.",
    hero_cta_primary: "Explore Properties",
    hero_cta_secondary: "Book a Free Consultation",

    // Trust bar
    trust_licensed: "UAE Licensed Agent",
    trust_experience: "10+ Years Experience",
    trust_clients: "500+ Clients Served",
    trust_volume: "AED 1B+ in Transactions",

    // Sections
    sec_developers_overline: "Trusted Partnerships",
    sec_developers_title: "Featured Developers",
    sec_developers_sub: "Unbiased access to the UAE's most respected names — no agency tie, no pressure.",

    sec_why_overline: "The Off-Plan Advantage",
    sec_why_title: "Why Invest Off-Plan in Dubai?",
    sec_why_1_title: "Higher ROI Potential",
    sec_why_1_body: "Buy at pre-launch prices and benefit from capital appreciation before handover — historically 15–35% gains by completion.",
    sec_why_2_title: "Flexible Payment Plans",
    sec_why_2_body: "Pay over 3–7 years with developer-backed schedules. Some projects require only 20% before handover.",
    sec_why_3_title: "Capital Appreciation",
    sec_why_3_body: "Dubai consistently ranks in the world's top growth markets — backed by Expo legacy, Vision 2040, and zero property tax.",

    sec_testimonials_overline: "Voices of Trust",
    sec_testimonials_title: "What Clients Say",

    sec_hot_overline: "Currently Hot",
    sec_hot_title: "Hand-Picked Launches",
    sec_hot_sub: "A curated selection of the most compelling off-plan opportunities this quarter.",

    // Property
    starting_from: "Starting from",
    handover: "Handover",
    payment_plan: "Payment Plan",
    request_details: "Request Details",
    view_all_properties: "View All Properties",
    roi_estimate: "Projected ROI",
    project_overview: "Project Overview",
    download_floor_plans: "Download Floor Plans",
    whatsapp_inquiry: "Inquire on WhatsApp",
    location: "Location",
    developer: "Developer",

    // Filters
    filter_developer: "Developer",
    filter_location: "Location",
    filter_budget: "Budget",
    filter_handover: "Handover Year",
    filter_all: "All",
    filter_reset: "Reset Filters",
    results_count: "results",

    // About
    about_overline: "Independent. Unbiased. Yours.",
    about_title: "Why I Work Independently",
    about_story_1: "After a decade inside the UAE's biggest brokerages, I realised the system rewards agents for selling what's on the shelf — not what's right for you. So I stepped out, kept my RERA licence, and built a practice with one rule: the client decides.",
    about_story_2: "Today I represent buyers — not developers. I assess every launch on its merits, surface the trade-offs other agents won't mention, and walk away from deals that don't make sense. That independence is the entire product.",
    about_approach_title: "My Approach",
    about_approach_1: "Unbiased advice across every developer — Emaar, DAMAC, Aldar, Sobha, Meraas, Nakheel and more.",
    about_approach_2: "Transparent on payment plans, service charges, ROI realism, and exit liquidity.",
    about_approach_3: "Long after handover, I stay in your corner — leasing, resale, portfolio review.",
    about_languages: "Languages",
    about_lang_list: "English · العربية · हिन्दी · Русский",
    about_rera: "RERA License No.",

    // Guide
    guide_overline: "Free Resource",
    guide_title: "The Complete Guide to Buying Off-Plan Property in Dubai",
    guide_sub: "Forty pages of plain-English clarity on the legal, financial and practical questions every off-plan buyer should ask before signing.",
    guide_form_title: "Download the Free Guide",
    guide_form_sub: "Enter your details — your PDF arrives in seconds.",
    guide_download: "Send Me the Guide",

    guide_s1_title: "What is Off-Plan?",
    guide_s1_body: "Off-plan means buying a property before construction is complete — directly from the developer at the lowest entry point. You secure today's price and pay in stages as the building rises.",
    guide_s2_title: "Legal Process (DLD & RERA)",
    guide_s2_body: "Every legitimate off-plan project is registered with the Dubai Land Department (DLD), with funds held in escrow under RERA supervision. Your Sales & Purchase Agreement (SPA), Oqood registration and DLD fee are non-negotiable safeguards.",
    guide_s3_title: "Payment Plans Explained",
    guide_s3_body: "Typical structures: 20/80, 40/60 and 60/40 post-handover. We help you match the plan to your cash flow — not just the headline price.",
    guide_s4_title: "ROI Calculator",
    guide_s4_body: "Estimate net yield (rental income minus service charges and DLD fees) and capital appreciation by handover. Try our calculator below.",
    guide_s5_title: "Risks & How to Mitigate Them",
    guide_s5_body: "Delays, service charge creep, oversupply pockets, exit liquidity. Each risk has a mitigation — and we explain every one.",

    // Calculator
    calc_title: "Off-Plan ROI Calculator",
    calc_price: "Property Price (AED)",
    calc_rent: "Expected Annual Rent (AED)",
    calc_service: "Service Charges (AED/yr)",
    calc_appreciation: "Expected Appreciation by Handover (%)",
    calc_net_yield: "Net Rental Yield",
    calc_total_return: "Projected Total Return",
    calc_calculate: "Calculate",

    // Contact
    contact_overline: "Let's Talk",
    contact_title: "Book a Free, No-Pressure Consultation",
    contact_sub: "Tell me a little about what you're looking for. I'll respond personally — usually within a few hours.",
    contact_name: "Full Name",
    contact_email: "Email",
    contact_whatsapp: "WhatsApp Number",
    contact_budget: "Budget Range",
    contact_pref_loc: "Preferred Location",
    contact_time: "Best Time to Call",
    contact_message: "Anything else I should know? (optional)",
    contact_submit: "Send Request",
    contact_thanks: "Thank you. I'll be in touch personally within hours.",
    contact_available: "Available for",
    contact_avail_list: "UAE Residents · International Investors · NRI Investors",

    // Newsletter
    nl_overline: "Members Only",
    nl_title: "Get Exclusive Off-Plan Launches Before They Go Public",
    nl_sub: "One concise email when something truly worth your attention launches. Unsubscribe anytime.",
    nl_placeholder: "Your email address",
    nl_cta: "Join the List",
    nl_thanks: "You're on the list.",

    // Cookies
    cookie_text: "We use cookies to enhance your browsing experience and analyse traffic. By continuing, you accept our use of cookies.",
    cookie_accept: "Accept",
    cookie_decline: "Decline",

    // Footer
    footer_disclaimer:
      "This website represents Mr. Real Estate Agent as an independent advisor and is not affiliated with any single brokerage. All property information is provided by developers and subject to change.",
    footer_tagline: "Helping smart investors find the right property in the UAE since 2014.",
    footer_quick: "Quick Links",
    footer_legal: "Legal",
    footer_connect: "Connect",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Use",
    footer_sitemap: "Sitemap",
    footer_rera_label: "RERA License",
    footer_dld_label: "DLD Registration",

    // 404
    not_found_title: "This page has yet to break ground.",
    not_found_sub: "Let's get you back to something worth your time.",
    not_found_cta: "Return Home",
  },
  ar: {
    nav_home: "الرئيسية",
    nav_properties: "العقارات",
    nav_about: "نبذة عني",
    nav_guide: "دليل الاستثمار",
    nav_contact: "تواصل",
    nav_book: "احجز استشارة",

    hero_overline: "مستشار مستقل · مرخص في الإمارات",
    hero_title: "دليلك الموثوق لأرقى استثمارات العقارات على الخريطة في دبي",
    hero_sub: "خبير مستقل. نصيحة صادقة. عقارات تُغيّر حياتك.",
    hero_cta_primary: "استكشف العقارات",
    hero_cta_secondary: "احجز استشارة مجانية",

    trust_licensed: "وكيل مرخص في الإمارات",
    trust_experience: "أكثر من 10 سنوات خبرة",
    trust_clients: "أكثر من 500 عميل",
    trust_volume: "صفقات تتجاوز مليار درهم",

    sec_developers_overline: "شراكات موثوقة",
    sec_developers_title: "المطوّرون المميّزون",
    sec_developers_sub: "وصول حيادي إلى أبرز المطوّرين في الإمارات — دون انحياز أو ضغط.",

    sec_why_overline: "ميزة العقارات على الخريطة",
    sec_why_title: "لماذا تستثمر في العقارات على الخريطة في دبي؟",
    sec_why_1_title: "عائد استثماري أعلى",
    sec_why_1_body: "اشترِ بأسعار ما قبل الإطلاق واستفد من ارتفاع رأس المال قبل التسليم — تاريخياً بنسبة 15-35% عند الاكتمال.",
    sec_why_2_title: "خطط دفع مرنة",
    sec_why_2_body: "ادفع على مدى 3-7 سنوات بجداول مدعومة من المطوّر. بعض المشاريع تتطلب 20% فقط قبل التسليم.",
    sec_why_3_title: "ارتفاع رأس المال",
    sec_why_3_body: "دبي ضمن أعلى أسواق النمو العالمية — مدعومة بإرث إكسبو ورؤية 2040 وانعدام الضرائب العقارية.",

    sec_testimonials_overline: "أصوات الثقة",
    sec_testimonials_title: "ماذا يقول العملاء",

    sec_hot_overline: "الأكثر طلباً الآن",
    sec_hot_title: "إطلاقات منتقاة بعناية",
    sec_hot_sub: "مجموعة مختارة من أفضل الفرص العقارية لهذا الربع.",

    starting_from: "ابتداءً من",
    handover: "التسليم",
    payment_plan: "خطة الدفع",
    request_details: "اطلب التفاصيل",
    view_all_properties: "عرض كل العقارات",
    roi_estimate: "العائد المتوقع",
    project_overview: "نظرة على المشروع",
    download_floor_plans: "تحميل المخططات",
    whatsapp_inquiry: "استفسر عبر واتساب",
    location: "الموقع",
    developer: "المطوّر",

    filter_developer: "المطوّر",
    filter_location: "الموقع",
    filter_budget: "الميزانية",
    filter_handover: "سنة التسليم",
    filter_all: "الكل",
    filter_reset: "إعادة الفلاتر",
    results_count: "نتيجة",

    about_overline: "مستقل. حيادي. لك.",
    about_title: "لماذا أعمل بشكل مستقل",
    about_story_1: "بعد عقد في أكبر شركات الوساطة في الإمارات، أدركت أن النظام يكافئ الوكلاء على بيع ما هو متوفر — لا ما يناسبك. فقررت العمل باستقلالية مع قاعدة واحدة: العميل يقرر.",
    about_story_2: "اليوم أمثّل المشترين — لا المطوّرين. أُقيّم كل مشروع بموضوعية، وأطرح المخاطر التي يتجنبها الآخرون، وأرفض الصفقات غير المنطقية. هذه الاستقلالية هي المنتج.",
    about_approach_title: "منهجي",
    about_approach_1: "نصيحة حيادية عبر كل المطوّرين — إعمار، داماك، الدار، صبحا، مراس، نخيل وغيرهم.",
    about_approach_2: "شفافية حول خطط الدفع ورسوم الخدمة وواقعية العائد وسيولة الخروج.",
    about_approach_3: "بعد التسليم، أبقى إلى جانبك — تأجير، إعادة بيع، مراجعة المحفظة.",
    about_languages: "اللغات",
    about_lang_list: "الإنجليزية · العربية · الهندية · الروسية",
    about_rera: "رقم رخصة RERA",

    guide_overline: "مورد مجاني",
    guide_title: "الدليل الشامل لشراء العقارات على الخريطة في دبي",
    guide_sub: "أربعون صفحة بلغة واضحة حول كل الأسئلة القانونية والمالية والعملية قبل التوقيع.",
    guide_form_title: "حمّل الدليل المجاني",
    guide_form_sub: "أدخل بياناتك — يصلك ملف PDF خلال ثوانٍ.",
    guide_download: "أرسل لي الدليل",

    guide_s1_title: "ما هي العقارات على الخريطة؟",
    guide_s1_body: "هي شراء العقار قبل اكتمال البناء — مباشرة من المطوّر بأقل سعر دخول، مع الدفع على مراحل أثناء الإنشاء.",
    guide_s2_title: "العملية القانونية (DLD و RERA)",
    guide_s2_body: "كل مشروع شرعي مسجّل لدى دائرة الأراضي والأملاك، والأموال في حسابات ضمان تحت إشراف RERA.",
    guide_s3_title: "خطط الدفع بالتفصيل",
    guide_s3_body: "الهياكل الشائعة: 20/80، 40/60، و60/40 بعد التسليم. نطابق الخطة مع تدفقك النقدي.",
    guide_s4_title: "حاسبة العائد",
    guide_s4_body: "احسب صافي العائد الإيجاري وارتفاع رأس المال بحلول التسليم.",
    guide_s5_title: "المخاطر وكيفية تقليلها",
    guide_s5_body: "التأخير، ارتفاع رسوم الخدمة، فائض العرض، سيولة الخروج — لكل خطر إستراتيجية تخفيف.",

    calc_title: "حاسبة العائد على العقارات على الخريطة",
    calc_price: "سعر العقار (درهم)",
    calc_rent: "الإيجار السنوي المتوقع (درهم)",
    calc_service: "رسوم الخدمة (درهم/سنة)",
    calc_appreciation: "الارتفاع المتوقع حتى التسليم (%)",
    calc_net_yield: "صافي العائد الإيجاري",
    calc_total_return: "العائد الإجمالي المتوقع",
    calc_calculate: "احسب",

    contact_overline: "لنتحدث",
    contact_title: "احجز استشارة مجانية دون أي ضغط",
    contact_sub: "أخبرني قليلاً عما تبحث عنه. سأرد عليك شخصياً — عادةً خلال ساعات.",
    contact_name: "الاسم الكامل",
    contact_email: "البريد الإلكتروني",
    contact_whatsapp: "رقم واتساب",
    contact_budget: "نطاق الميزانية",
    contact_pref_loc: "الموقع المفضل",
    contact_time: "أفضل وقت للاتصال",
    contact_message: "أي شيء آخر تود إخباري به؟ (اختياري)",
    contact_submit: "إرسال الطلب",
    contact_thanks: "شكراً لك. سأتواصل معك شخصياً خلال ساعات.",
    contact_available: "متاح للعمل مع",
    contact_avail_list: "مقيمي الإمارات · المستثمرين الدوليين · المستثمرين من الهند",

    nl_overline: "للأعضاء فقط",
    nl_title: "احصل على الإطلاقات الحصرية قبل طرحها للعموم",
    nl_sub: "بريد واحد مختصر عند إطلاق ما يستحق اهتمامك. إلغاء الاشتراك في أي وقت.",
    nl_placeholder: "بريدك الإلكتروني",
    nl_cta: "انضم للقائمة",
    nl_thanks: "تم تسجيلك بنجاح.",

    cookie_text: "نستخدم ملفات تعريف الارتباط لتحسين تجربتك. بمواصلة التصفح، فإنك توافق على استخدامها.",
    cookie_accept: "موافق",
    cookie_decline: "رفض",

    footer_disclaimer:
      "يمثل هذا الموقع السيد وكيل العقارات كمستشار مستقل وغير مرتبط بأي وساطة. جميع معلومات العقارات مقدمة من المطوّرين وقابلة للتغيير.",
    footer_tagline: "نساعد المستثمرين الأذكياء على إيجاد العقار المناسب في الإمارات منذ 2014.",
    footer_quick: "روابط سريعة",
    footer_legal: "قانوني",
    footer_connect: "تواصل",
    footer_privacy: "سياسة الخصوصية",
    footer_terms: "شروط الاستخدام",
    footer_sitemap: "خريطة الموقع",
    footer_rera_label: "رخصة RERA",
    footer_dld_label: "تسجيل DLD",

    not_found_title: "لم يتم بناء هذه الصفحة بعد.",
    not_found_sub: "لنعيدك إلى ما يستحق وقتك.",
    not_found_cta: "العودة للرئيسية",
  },
};